import { render, staticRenderFns } from "./ModernHome.vue?vue&type=template&id=1c57d2c0&scoped=true"
import script from "./ModernHome.vue?vue&type=script&lang=js"
export * from "./ModernHome.vue?vue&type=script&lang=js"
import style0 from "./ModernHome.vue?vue&type=style&index=0&id=1c57d2c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57d2c0",
  null
  
)

export default component.exports